export const USER_SAVE = "USER_SAVE";
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_NAME_SAVE = "USER_NAME_SAVE";
export const USER_BRANCH_SAVE = "USER_BRANCH_SAVE";
export const USER_CONECTION = "USER_CONECTION";
export const USER_VIDEO_TUTORIAL = "USER_VIDEO_TUTORIAL";
